'use strict';

export default class CrmContribution {
  constructor() {
    this.name = 'crm-contribution';
    this.contribWrapper = $('.crm-contribution-main-form-block');
    this.contribWrapper.show();
    if(this.contribWrapper.length < 1) return;

    this.convertToMultistep();
    this.initHasMoreChild();
    this.registerEvents();
  }

  convertToMultistep() {
    var self = this;
    var contribWrapper = this.contribWrapper;

    var radios = contribWrapper.find("input[type='radio']", "input[type='checkbox']");
    $("#crm-container").addClass("display-block");
    contribWrapper.find('.recaptcha-section').hide();
    radios.wrap($(`<span/>`));
    radios.after($(`<span class='checkmark'>Check</span>`))

    $('body').on('click', '.checkmark', function(e) {
      $(this).prev().click();
    });

    $('#intro_text').hide();

    var steps = {
      'personal-details': {
        label: 'Personal details',
        elements: ['.crm-other-contact-row','.crm-not-you-message','.cms_user-section', '.custom_pre_profile-group'],
        active: true,
        classes: ['row', 'extra']
      },
      'more-details': {
        label: 'Details',
        elements: ['.custom_post_profile-group'],
        active: false,
        classes: ['row', 'extra']
      },
      'payment': {
        label: 'Payment',
        elements: ['#membership','#billing-payment-block', "#priceset-div"],
        active: false,
        classes: ['row', 'block', 'col-two']
      }
    }

    if(contribWrapper.find('.custom_post_profile-group .crm-profile').length < 1) {
      
      delete steps['more-details'];
    }
    

    var stepKeys = Object.keys(steps);
    var currentStepKey = 'personal-details';
    var firstStepKey = Object.keys(steps)[0];
    var lastStepKey = Object.keys(steps).pop();

    var wrapper = $("<div/>", { class: 'multi-step-form', id: 'multi-step-form' });

    var tabs = $(`
      <ul class='tabs'></ul>
    `);

    Object.keys(steps).forEach(function(key, index) {
      var link = $(`<li><a href="#${key}" class="${steps[key].active ? 'active' : ''}" data-step-key="${key}">${steps[key].label}</a></li>`);
      tabs.append(link);
      var classNames = '';
      if(steps[key].classes)
        classNames = steps[key].classes.join(" ");

      var stepContainer = $(`<div id="${key}" data-step="${index}" class="step ${steps[key].active ? 'active' : ''} ${classNames}"></div>`);
      // stepContainer.append(`<h2>${steps[key].label}</h2>`);
      if(key == 'personal-details') {
        var intro = $('#intro_text').clone();
        intro.show();
        stepContainer.prepend(intro);
      }

      if(key == 'payment') {
        var paymentWrapper = $(`<div class="payment-wrapper"></div>`);
      }
      
      steps[key].elements.forEach(element => {
        if(paymentWrapper) {
          paymentWrapper.append(contribWrapper.find(element).detach());
          paymentWrapper.append($(".recaptcha-section").detach());
          paymentWrapper.find(".recaptcha-section").css("margin-left", "-20px");
        } else {
          stepContainer.append(contribWrapper.find(element).detach());
        }
      });

      if(paymentWrapper) {
        stepContainer.append(paymentWrapper);
        stepContainer.append($("#footer_text"));
      }
      wrapper.append(stepContainer);
    });


    var nextButton = $(`
      <button class="button pink next-button" type="button">
        Next step <span class="icon-chevron"></span>
      </button>
    `);

    var prevButton = $(`
      <button class="button yellow prev-button" type="button">
        <span class="icon-chevron"></span>Previous step
      </button>
    `);

    prevButton.hide();

    nextButton.click(function(e) {
      e.preventDefault();
      var currentStep = wrapper.find(`#${currentStepKey}`);

      var isValid = self.validateSection(currentStep);

      if(!isValid) {
        $('#block-aba-content')[0].scrollIntoView();
        return;
      }

      var index = stepKeys.indexOf(currentStepKey);
      var nextStepKey = stepKeys[index+1];
      steps[currentStepKey].active = false;
      steps[nextStepKey].active = true;
      prevButton.show();

      currentStepKey = nextStepKey;

      if(currentStepKey == lastStepKey) {
        nextButton.hide();
        contribWrapper.find('.recaptcha-section').show();
        contribWrapper.find(".crm-form-submit").show();
      } else {
        contribWrapper.find(".crm-form-submit").hide();
        nextButton.show();
      }

      tabs.find('.active').removeClass('active');
      tabs.find(`a[data-step-key=${currentStepKey}]`).addClass('active');
      wrapper.find('.step').removeClass('active');
      wrapper.find(`#${currentStepKey}`).addClass('active');
      $('#block-aba-content')[0].scrollIntoView();
    });

    prevButton.click(function(e) {
      e.preventDefault();
      var index = stepKeys.indexOf(currentStepKey);
      var nextStepKey = stepKeys[index-1];
      steps[currentStepKey].active = false;
      steps[nextStepKey].active = true;

      currentStepKey = nextStepKey;
      contribWrapper.find(".crm-form-submit").hide();
      nextButton.show();
      contribWrapper.find('.recaptcha-section').hide();
      if(currentStepKey == firstStepKey) {
        prevButton.hide();
      } else {
        prevButton.show();
      }

      tabs.find('.active').removeClass('active');
      tabs.find(`a[data-step-key=${currentStepKey}]`).addClass('active');
      wrapper.find('.step').removeClass('active');
      wrapper.find(`#${currentStepKey}`).addClass('active');
      $('#block-aba-content')[0].scrollIntoView();
    });
    contribWrapper.find('#crm-submit-buttons').prepend(prevButton);
    contribWrapper.find('#crm-submit-buttons').append(nextButton);
    contribWrapper.find(".crm-form-submit").hide();
    contribWrapper.prepend(tabs);
    contribWrapper.find("#intro_text").after(wrapper);
    contribWrapper.show();
    
    if($("#crm-main-content-wrapper").find('.crm-error').length > 0) {
      prevButton.show();

      currentStepKey = lastStepKey;
      nextButton.hide();
      contribWrapper.find('.recaptcha-section').show();
      contribWrapper.find(".crm-form-submit").show();


      tabs.find('.active').removeClass('active');
      tabs.find(`a[data-step-key=${currentStepKey}]`).addClass('active');
      wrapper.find('.step').removeClass('active');
      wrapper.find(`#${currentStepKey}`).addClass('active');
      $('#block-aba-content')[0].scrollIntoView();
    }
  }

  initHasMoreChild() {
    this.hasMoreChildField = "input[name=custom_303]";
    var self = this;
    var birthdayFields = ["304", "305"];

    birthdayFields.forEach(function(fieldId, index) {
      self.hideField(fieldId);
    });

    $('body').on('change', this.hasMoreChildField , function() {
      var lastVisibleField = undefined;
      var hasMoreChild = self.hasMoreChild();

      birthdayFields.forEach(function(fieldId, index) {
        if(hasMoreChild == 1 && (index == 0 || $(`#custom_${fieldId}`).val().length > 0)) {
          self.showField(fieldId);
          lastVisibleField = fieldId;
        } else {
          self.hideField(fieldId);
        }
      });

      $("#add-more-child").addClass("visually-hidden");

      var currentVisibleIndex = birthdayFields.indexOf(lastVisibleField);

      if(
        hasMoreChild &&
        !(
          currentVisibleIndex < 0 ||
          (currentVisibleIndex + 1) >= birthdayFields.length
        )
      ) {
        $("#add-more-child").removeClass("visually-hidden");
      }
    });

    $('body').on('click', "#add-more-child", function(e) {
      var lastVisibleField = undefined;

      birthdayFields.forEach(function(fieldId, index) {
        if($(`.editrow_custom_${fieldId}-section`).is(":visible")) lastVisibleField = fieldId;
      });

      var currentVisibleIndex = birthdayFields.indexOf(lastVisibleField);

      if(currentVisibleIndex < 0) return;

      $("#add-more-child").addClass("visually-hidden");

      self.showField(birthdayFields[(currentVisibleIndex + 1)]);

      if((currentVisibleIndex + 2) >= birthdayFields.length) return;

      $("#add-more-child").removeClass("visually-hidden");
    });

    $(this.hasMoreChildField).change();
  }

  hasMoreChild() {
    if($(this.hasMoreChildField).length < 1) return false;

    return $(`${this.hasMoreChildField}:checked`).val();
  }

  showField(fieldId) {
    $(`.helprow-custom_${fieldId}-section`).show();
    $(`.editrow_custom_${fieldId}-section`).show();
  }

  hideField(fieldId) {
    $(`.helprow-custom_${fieldId}-section`).hide();
    $(`.editrow_custom_${fieldId}-section`).hide();
  }

  validateSection(section) {
    var self = this;
    var crmRequiredInputSections = section.find('input.required, select.required').closest('.crm-section');

    var errorCount = 0;

    Object.values(crmRequiredInputSections).forEach(function(crmSection) {
      var input = $(crmSection).find('input.required, select.required');

      if(input.length != 1) {
        console.log(input, 'More than one or none', input.length);
      } else {
        if(!self.validateRequired($(input[0]))) {
          errorCount++;
        }
      }
    });

    return (errorCount < 1);
  }

  registerEvents() {
    var self = this;
    var contribWrapper = this.contribWrapper;

    // value change event
    (function() {
      contribWrapper.on('change', 'input.required, select.required', function(e) {
        self.validateRequired($(this));
      });
    })();
  }

  validateRequired(input) {
    var value = input.val().trim();

    if(value.length < 1) {
      var attrId = input.attr('id');
      var errorLabel = input.next(`#${attrId}-error`);

      if(errorLabel.length >=  1) errorLabel.remove();

      errorLabel = $('<label/>', {
        id: `${attrId}-error`,
        class: 'crm-inline-error alert-danger',
        for: attrId,
        html: 'This field is required.'
      });

      input.after(errorLabel);

      return false;
    }

    return true;
  }
}
